import styled from 'styled-components'
import { NavLink as RouterNavLink } from 'react-router-dom'
import { Popover as MuiPopover } from '@material-ui/core'
import { getFontStyle, makeLineClamp } from '@diversioteam/diversio-ds'

export const PulseSurveysWrapper = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const Header = styled.header`
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${({ theme }) => theme.colors.purple90};
    position: relative;

    ${getFontStyle('p01Medium')};
`

export const Title = styled.h2`
    max-width: 300px;
    word-break: break-all;

    ${getFontStyle('p01Medium')};

    ${makeLineClamp(1)}
`

export const SavingStatus = styled.div`
    margin-left: 12px;
    color: ${({ theme }) => theme.colors.secondary500};

    ${getFontStyle('p03Regular')};
`

export const Routes = styled.div`
    position: absolute;
    left: 50%;
    right: 50%;
    display: flex;
    gap: 12px;
`

export const NavLink = styled(RouterNavLink)`
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 4px 8px;
    color: ${({ theme }) => theme.colors.secondary500};
    position: relative;

    ${getFontStyle('p02Semibold')};

    &.active {
        color: ${({ theme }) => theme.colors.primary60};

        &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 2px;
            background-color: ${({ theme }) => theme.colors.primary50};
        }
    }
`

export const NavLinkDisabled = styled(NavLink)`
    color: ${({ theme }) => theme.colors.secondary300};
    cursor: default;
`

export const Popover = styled(MuiPopover)`
    .MuiPopover-paper {
        width: 500px;
        margin-top: 24px;
        box-shadow: none;
        border-radius: 15px;
    }
`

export const ResponsiveButtonWrapper = styled.div`
    @media (max-width: 992px) {
        display: none;
    }
`
